var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Rota","titleIcon":"fas fa-map-signs"}},[_c('form-rota',{attrs:{"paramId":_vm.id},on:{"onSubmitRota":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }